module.exports = __webpack_public_path__ + "img/icoon_buitenweekend_small.3a745b7e.svg";